import { useEffect, useState } from 'react'

import { Flex } from 'antd'
import {
  CAN_UNDO_COMMAND,
  COMMAND_PRIORITY_CRITICAL,
  UNDO_COMMAND
} from 'lexical'

import { WpsUndoIcon } from '@eastcoal/icon/WpsUndoIcon'

import { useEditor } from '../../hooks/useEditor'
import { SHORTCUTS } from '../../plugins/ShortcutsPlugin/shortcuts'
import { MenuButton } from '../../ui/MenuButton'

export const UndoButton = () => {
  const [canUndo, setCanUndo] = useState(false)

  const editor = useEditor()

  useEffect(() => {
    return editor.registerCommand<boolean>(
      CAN_UNDO_COMMAND,
      payload => {
        setCanUndo(payload)
        return false
      },
      COMMAND_PRIORITY_CRITICAL
    )
  }, [editor])

  const handleUndo = () => {
    editor.dispatchCommand(UNDO_COMMAND, undefined)
  }

  return (
    <MenuButton
      disabled={!canUndo}
      tooltip={
        <Flex vertical align='center'>
          <span>撤销</span>
          <span>{SHORTCUTS.UNDO}</span>
        </Flex>
      }
      onClick={handleUndo}
    >
      <WpsUndoIcon />
    </MenuButton>
  )
}
